var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereumEthLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 784.37 1277.39",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsXodm: "http://www.corel.com/coreldraw/odm/2003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1421394342400"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#343434",
    fillRule: "nonzero",
    points: "392.07,0 383.5,29.11 383.5,873.74 392.07,882.29 784.13,650.54 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C8C8C",
    fillRule: "nonzero",
    points: "392.07,0 -0,650.54 392.07,882.29 392.07,472.33 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3C3C3B",
    fillRule: "nonzero",
    points: "392.07,956.52 387.24,962.41 387.24,1263.28 392.07,1277.38 784.37,724.89 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8C8C8C",
    fillRule: "nonzero",
    points: "392.07,1277.38 392.07,956.52 -0,724.89 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#141414",
    fillRule: "nonzero",
    points: "392.07,882.29 784.13,650.54 392.07,472.33 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#393939",
    fillRule: "nonzero",
    points: "0,650.54 392.07,882.29 392.07,472.33 "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumEthLogo);
export default __webpack_public_path__ + "static/media/ethereum-eth-logo.3fd82e9f35ffed062794d2e5cfb7e7e8.svg";
export { ForwardRef as ReactComponent };